import { render, staticRenderFns } from "./MercadoPagoForm.vue?vue&type=template&id=154c57dc&scoped=true&"
import script from "./MercadoPagoForm.vue?vue&type=script&lang=js&"
export * from "./MercadoPagoForm.vue?vue&type=script&lang=js&"
import style0 from "./MercadoPagoForm.vue?vue&type=style&index=0&id=154c57dc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154c57dc",
  null
  
)

export default component.exports